<p>advanced-price-edit works!</p>
